var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "root", attrs: { "max-width": "1400" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct(_vm.titleKey)) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              staticClass: "mrs",
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c("app-edit-product", {
        attrs: { "drawer-button-disabled": "" },
        on: {
          cancel: function ($event) {
            return _vm.cancel()
          },
          input: function ($event) {
            return _vm.finish()
          },
          "product-saved": function ($event) {
            return _vm.onProductSave($event)
          },
        },
        model: {
          value: _vm.p,
          callback: function ($$v) {
            _vm.p = $$v
          },
          expression: "p",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }